import { TokenFull } from 'types/api';

export const getPropertyValue = (props: TokenFull['properties'], label: string): string =>
  String(props?.find((item) => item.traitType === label)?.traitValue || '');
